import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useDropdown } from '@trevor/ui-components';
import type { SavedQuery } from '@/types';
import { SAVED_QUERY_SELECTED, SAVED_QUERY_UPDATED } from '@/actions/constants';
import { SavedQueriesWidget as SavedQueriesWidgetBase } from '@/features/savedQueriesWidget/SavedQueriesWidget';
import { START_FROM_SAVED_QUERY_DROPDOWN } from '@/features/savedQueriesWidget/widgetRenderContext.constants';
import {
  FilterBar,
  SearchControlsContainer,
  SearchTermContainer,
} from '@/features/savedQueriesWidget/styled-components';

const Container = styled.div`
  background-color: #fff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
  width: 345px;

  ${FilterBar} {
    padding: 0;
    margin: 0;
  }

  ${SearchTermContainer} {
    border-bottom: 1px solid #e8e8e8;
    padding: 16px;
  }

  ${SearchControlsContainer} {
    border-bottom: 1px solid #e8e8e8;
    padding: 14px;
    width: 100%;

    & > div {
      margin-left: auto;
    }
  }
`;

export const SavedQueriesWidget: React.FC<{
  isExistingLayer: boolean;
}> = ({ isExistingLayer = false }) => {
  const dispatch = useDispatch();
  const { toggle } = useDropdown();

  const handleSelectQuery = (query: SavedQuery) => {
    dispatch({
      type: isExistingLayer ? SAVED_QUERY_UPDATED : SAVED_QUERY_SELECTED,
      payload: query,
    });
    toggle();
  };

  return (
    <Container>
      <SavedQueriesWidgetBase
        onSelectQuery={handleSelectQuery}
        mode={START_FROM_SAVED_QUERY_DROPDOWN}
      />
    </Container>
  );
};
